export const GET_CUSTOM_SUCCESS = 'embed/GET_CUSTOM_SUCCESS'
export const SET_THEME = 'embed/SET_THEME'
export const GET_BRAND_SUCCESS = 'embed/GET_BRAND_SUCCESS'
export const UPDATE_BRAND_GATING = 'embed/UPDATE_BRAND_GATING'
export const SET_TERMS_AGREED = 'embed/SET_TERMS_AGREED'


// WEBPACK FOOTER //
// ./assets/embed/actionTypes.js